import type { PropsWithChildren } from 'react';
import React from 'react';

import VehicleCard from 'Components/shared/VehicleCards/VehicleCard/VehicleCard';
import VehicleCardContextAndRTBWrapper from 'Components/shared/VehicleCards/VehicleCard/VehicleCardContextAndRTBWrapper';
import VehicleCardLoadingView from 'Components/shared/VehicleCards/VehicleCard/VehicleCardLoadingView/VehicleCardLoadingView';
import { triggerVehicleCardClickEvent, triggerVehicleShortlistedEvent } from 'Services/analytics/events';
import { useTriggerVehicleCardClickedEvent } from 'Services/optimizely/events/useTriggerVehicleCardClickedEvent';
import type { VehicleListItem } from 'Types/vehicle';

import VehicleCardView from '../../shared/VehicleCards/VehicleCard/VehicleCardView/VehicleCardView';

interface VehicleListCardProps {
	className: string;
	loading: boolean;
	loadingView: React.ReactNode;
	vehicle: VehicleListItem;
}

const VehicleListCard = ({ vehicle, ...rest }: PropsWithChildren<VehicleListCardProps>) => {
	const triggerVehicleCardClickedEvent = useTriggerVehicleCardClickedEvent();

	const onCardClick = () => {
		triggerVehicleCardClickedEvent(vehicle.state.slug);
		triggerVehicleCardClickEvent(vehicle.id);
	};

	return (
		<VehicleCard {...rest} loadingView={<VehicleCardLoadingView />} onClick={onCardClick} vehicle={vehicle}>
			<VehicleCardContextAndRTBWrapper vehicle={vehicle}>
				<VehicleCardView
					displayPaidListingIcon
					onClickShortlist={({ id, isChecked, page }: { id: number; isChecked: boolean; page: string }) =>
						triggerVehicleShortlistedEvent({ id, isChecked, page })
					}
					page={'vehicle list'}
				/>
			</VehicleCardContextAndRTBWrapper>
		</VehicleCard>
	);
};

export default VehicleListCard;
